import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['frame', 'results']
  static values = { url: String }

  connect () {
    this.onFormEvent = (event) => this.clearUnlessKept(event)
    this.form?.addEventListener('input', this.onFormEvent)
    this.form?.addEventListener('change', this.onFormEvent)
  }

  disconnect () {
    this.form?.removeEventListener('input', this.onFormEvent)
    this.form?.removeEventListener('change', this.onFormEvent)
  }

  isolate (event) {
    event.stopPropagation()
  }

  load (event) {
    event.preventDefault()
    if (!this.hasFrameTarget || !this.hasUrlValue || !this.form) return

    const params = new URLSearchParams()
    new FormData(this.form).forEach((value, key) => {
      if (key === 'authenticity_token' || key === 'utf8') return
      params.append(key, value)
    })
    const url = new URL(this.urlValue, window.location.origin)
    url.search = params.toString()
    const next = url.toString()
    if (this.frameTarget.src === next) {
      this.frameTarget.reload()
      return
    }

    this.frameTarget.src = next
  }

  clearUnlessKept (event) {
    if (event.target?.closest?.('[data-form-frame-src-keep]')) return

    this.clear()
  }

  clear () {
    if (!this.hasFrameTarget) return

    this.frameTarget.removeAttribute('src')
    if (this.hasResultsTarget) this.resultsTarget.replaceChildren()
  }

  get form () {
    return this.element.closest('form')
  }
}
